import React from 'react';

type Props = {
  children: React.ReactNode;
};

export const ProgramListItem: React.FC<Props> = ({ children }) => (
  <li>{children}</li>
);
